import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
// import DataTable from 'react-data-table-component';

import arrowPurple from '../../imgs/icons/arrowPurple.svg';

import BackArrowtoFirst from '../../imgs/icons/back-arrow-to-first.svg';

import PopupComp from '../../components/Popup.js';

import notificheNode from 'node/notifiche/notifiche.js';
import sensoriNode from 'node/sensori/sensori.js';

import BedAlertIcon from '../../imgs/svg/BedAlertIcon.js'
import ResidentAlertIcon from '../../imgs/svg/ResidentAlertIcon.js'

import lang from "../../lang.json";
import { CSVLink, CSVDownload } from "react-csv";
import falldetected from "../../imgs/icons/falldetected.svg";
import emptyroom from "../../imgs/icons/emmptyroom.svg";
import exitdoor from "../../imgs/icons/exit_door.svg";
import exitdoor_confermata from "../../imgs/icons/exit_door_confermata.svg";
import enterdoor from "../../imgs/icons/enter_door.svg";
import enterdoor_confermata from "../../imgs/icons/enter_door_confermata.svg";

const langSet = lang[localStorage.getItem("lang")].notifiche;



export default function Index(props) {
    const accountData = JSON.parse(localStorage.getItem("account"));
    const [sort, setSort] = useState('creato');
    const [order, setOrder] = useState('asc');
    const [notifiche, setNotifiche] = useState([]);
    const [infosPopup, setInfosPopup] = useState(['']);
    const [dragPosition, setDragPosition] = useState(null);
    const [page, setPage] = useState(0);
    const [sensori, setSensori] = useState([]);

    const [data, setData] = useState([]);

    const headers = [
        { label: "Tipologia allerta", key: "tipologiaAllerta" },
        { label: "Dove", key: "dove" },
        { label: "Data e ora", key: "date" }
    ];

    async function Sort(sorting) { // sorting = nome colonna
        props.loading(true);
        setSort(sorting);
        let sortBy = sorting;
        let orderBy = '';
        let arrow = document.getElementById(`Arrow${sorting}`);
        if (order === 'desc') {
            orderBy = 'asc';
            setOrder('asc');
            arrow.style.transform = "rotate(0deg)";
        } else {
            orderBy = 'desc';
            setOrder('desc');
            arrow.style.transform = "rotate(180deg)";
        }
        await getNot(sortBy, orderBy);
        await getNotjson(sortBy, orderBy);
        props.loading(false);
    }

    async function getNot(sorting, orderBy) { // get per le notifiche
        props.loading(true);
        await notificheNode.getNotifiche(accountData.token, sorting, orderBy).then((res) => {
            if(!res.result) throw res.error;
            setNotifiche(res.data);

            const jsonData = res.data.map((notifica, index) => {
                return {
                    "tipologiaAllerta": notifica.messaggio === 'Il paziente è caduto' 
                                            ? 'Possibile caduta' 
                                            : notifica.messaggio === 'Il letto è vuoto' 
                                                ? 'Uscita letto' 
                                                : notifica.messaggio
                                        ,
                    "dove": notifica.residente !== '' 
                                ? notifica.residente.replace('Stanza', 'Letto') 
                                : notifica.id_stanza
                            ,
                    "date": notifica.creato
                };
            });
            setData(jsonData);
        });
        props.loading(false);
    }

    async function getNotjson(sorting, orderBy) { // get per le notifiche
        props.loading(true);
        await notificheNode.getNotifiche(accountData.token, sorting, orderBy).then((res) => {
            if(!res.result) throw res.error;

            if (notifiche === undefined) {
                return (
                    <div id="noData">
                        <p>{langSet.erroreCaricamento}</p>
                    </div>
                );
            } else {

            }

            const jsonData = notifiche.map((notifica, index) => {
                return {
                    "tipologiaAllerta": notifica.messaggio === 'Il paziente è caduto' ? 'Possibile caduta' : notifica.messaggio === 'Il letto è vuoto' ? 'Uscita letto' : notifica.messaggio,
                    "dove": notifica.residente !== '' ? notifica.residente.replace('Stanza', 'Letto') : notifica.id_stanza,
                    "date": notifica.creato
                };
            });

            console.log(jsonData);

            setData(jsonData);
        });
        props.loading(false);
    }


    useEffect(() => {
        props.loading(true);
        setTimeout(() => {
            setSort(props.sortBy);
            setOrder(props.orderBy);
            getNot(props.sortBy, props.orderBy);
            props.loading(false);
        }, 500);
    }, [localStorage.getItem('struttura')]);

    function centraPopup() { dragPosition === null ? setDragPosition({ x: 0, y: 0 }) : setDragPosition(null); }

    function openPopup(category, info, operation, data) {
        document.getElementById("Popup").style.display = "flex";
        setInfosPopup([{ category, info, operation, data }]);
    }

    function closePopup() {
        document.getElementById("Popup").style.display = "none";
    }

    function SchedaInScheda(category, info, operation, data, previousPage) { // per aprire una scheda dentro una scheda
        setInfosPopup([{ category, info, operation, data, previousPage }]);
    }

    useEffect(() => {
        getSensori();
    }, []);

    async function getSensori() { // get per i sensori
        props.loading(true);
        await sensoriNode.getSensori(accountData.token).then((res) => {
            if(!res.result) throw res.error;
            setSensori(res.data);
        });
        props.loading(false);
    }

    function getNomeSensore(id) { // prende il nome del sensore
        let nome = '';
        sensori.forEach((sensore) => { // prende il nome del sensore
            if (sensore.id === id) {
                nome = sensore.nome;
            }
        });
        return nome;
    }

    return (
        <>
            <div id="loading"/>
            <div id="Popup">
                <Draggable handle="#handle" position={dragPosition}>
                    <div className="popupContent">
                        <PopupComp info={infosPopup} getNot={getNot} closePopup={closePopup} loading={props.loading}
                                   SchedaInScheda={SchedaInScheda}/>
                    </div>
                </Draggable>
            </div>

            <div id="table-scroll" className="table-scroll table-scroll2"
                 style={{height: "calc(100% - 4.5em)", marginTop: "1rem"}}>
                <table id="TitoliLista" className="main-table" style={{width: "100%"}}>
                    <thead style={{
                        borderTop: "1px solid #F5F5F5",
                        borderBottom: "1px solid #CDDEFF",
                        borderRadius: "10px"
                    }}>
                    <tr style={{color: "#4DA6DD"}}>

                        <th style={{zIndex: 100, borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px"}} colspan="2"
                            className={sort === 'messaggio' ? 'selected' : null} onClick={() => Sort('messaggio')}>
                            {/*{langSet.messaggio}*/}
                            Tipologia allerta
                            &nbsp; <img src={arrowPurple} alt='arrow' className='arrowTitoli white'
                                        id='Arrowmessaggio'/></th>
                        <th style={{zIndex: 100}} className={sort === 'residente' ? 'selected' : null}
                            onClick={() => Sort('residente')}>
                            {/*{langSet.residente}*/}
                            Dove
                            &nbsp; <img src={arrowPurple} alt='arrow' className='arrowTitoli' id='Arrowresidente'/></th>
                        {/*<th style={{ zIndex:100 }} >{langSet.stanza} </th>*/}
                        <th style={{borderTopRightRadius: "20px", borderBottomRightRadius: "20px", zIndex: "100"}}
                            className={sort === 'creato' ? 'selected' : null} onClick={() => Sort('creato')}>
                            {/*{langSet.creatoIl} */}
                            Data e ora
                            &nbsp; <img src={arrowPurple} alt='arrow' className='arrowTitoli' id='Arrowcreato'/></th>

                    </tr>
                    </thead>

                    <tbody style={{fontSize: "medium", color: "black"}} className="tablestraip">

                    {notifiche === undefined ?
                        <div id="noData">
                            <p>{langSet.erroreCaricamento}</p>
                        </div>
                        : notifiche.slice(page * 30, (page + 1) * 30).map((notifica, index) => {

                            // console.log({notifica});

                            return (
                                <tr id="Lista" key={index} className={notifica.confermata ? "" : "allarme alerta bold"}
                                    style={{cursor: "pointer"}} onClick={() => openPopup('scheda_notifica', notifica)}>

                                    <td style={{textAlign: "center"}}>
                                        {(() => {
                                            switch(notifica.tipo) {
                                            //// old code that was using messaggio ////
                                            case 'allarme':
                                              switch(notifica.messaggio) {
                                              case 'Il paziente è caduto':
                                                  return <img src={falldetected} alt="allarme" />
                                              case 'Il letto è vuoto':
                                                  return(
                                                  notifica.confermata
                                                      ? <BedAlertIcon fill="#C9CACE" />
                                                      : <BedAlertIcon fill="#333333" />
                                                  )
                                              case 'la stanza è vuota':
                                                  return(
                                                  notifica.confermata
                                                      ? <img src={emptyroom} alt="libero" />
                                                      : <ResidentAlertIcon fill="#333333" />
                                                  )
                                              }

                                            /* NEW CODE (tipo) */
                                            case 'leaving_sensor_room':
                                            case 'leaving_room':
                                                return(
                                                    notifica.confermata
                                                        ? <img src={exitdoor_confermata} alt="allarme" />
                                                        : <img src={exitdoor} alt="allarme" />
                                                )

                                            case 'entering_sensor_room':
                                            case 'entering_room':
                                                return(
                                                    notifica.confermata
                                                        ? <img src={enterdoor_confermata} alt="allarme" />
                                                        : <img src={enterdoor} alt="allarme" />
                                                )

                                            case 'out_of_bed':
                                            case 'letto':
                                              return(
                                                  notifica.confermata
                                                      ? <BedAlertIcon fill="#C9CACE" />
                                                      : <BedAlertIcon fill="#333333" />
                                                  )

                                            default:
                                                return null;
                                            }
                                        })()}
                                    </td>

                                    <td style={{textAlign: "start"}}>
                                        {notifica.messaggio == 'Il paziente è caduto' 
                                            ? 'Possibile caduta' 
                                            : notifica.messaggio == 'Il letto è vuoto' 
                                                ? 'Uscita letto' 
                                                : notifica.messaggio}
                                    </td>

                                    <td style={{textAlign: "center"}}>
                                        {notifica.residente != '' ? notifica.residente.replace('Stanza', 'Letto') : notifica.id_stanza}
                                    </td>
                                    <td style={{textAlign: "center"}}>
                                        {notifica.creato}
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>

            <div id="Header" style={{width: "100%"}}>
                <div>
                    <CSVLink data={data} headers={headers} className="selettore selettoreFlex"
                             filename="Export_allerte.csv"
                             style={{
                                 background: "#00A3DF",
                                 color: "white",
                                 textDecoration: "none",
                                 marginRight: "20px",
                                 marginLeft: "0px"
                             }}>
                        <p>Esporta in csv</p>
                    </CSVLink>
                </div>
                {notifiche ?
                    <>
                        <div className='headerDX' style={{marginRight: "10px"}}>
                        <div className='selettore selettoreFlex' style={{cursor: 'default'}}>

                                {Math.ceil(notifiche.length / 30) > 1 && (
                                    <img src={BackArrowtoFirst}
                                         style={{width: '1.2rem', margin: '4px'}}
                                         onClick={() => setPage(0)}/>
                                )}
                                <img
                                    src={arrowPurple}
                                    style={{transform: "rotate(90deg)", width: '1.2rem', margin: '4px'}}
                                    onClick={() => page > 0 ? setPage(page - 1) : null}
                                />
                                <div style={{
                                    fontWeight: 200,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: 'default'
                                }}>{langSet.pagina}&nbsp;{page + 1} / <p
                                    onClick={() => setPage(Math.ceil(notifiche.length / 30) - 1)}>{Math.ceil(notifiche.length / 30)}</p>
                                </div>
                                <img
                                    src={arrowPurple}
                                    style={{transform: "rotate(-90deg)", width: '1.2rem', margin: '4px'}}
                                    onClick={() => page < Math.ceil(notifiche.length / 30) - 1 ? setPage(page + 1) : null}
                                />
                                {Math.ceil(notifiche.length / 10) > 1 && (
                                    <img src={BackArrowtoFirst}
                                         style={{transform: "rotate(180deg)", width: '1.2rem', margin: '4px'}}
                                         onClick={() => setPage(Math.ceil(notifiche.length / 30) - 1)}/>
                                )}
                            </div>
                        </div>
                    </> :
                    <>
                    </>
                }
            </div>

        </>
    );
}